import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IncludedBadge',
    props: {
        itemName: null,
        included: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faCheck, faTimes);
        const variant = computed(() => {
            return props.included ? "primary" : "secondary";
        });
        return { __sfc: true, props, variant, FontAwesomeIcon, BBadge };
    }
});
